import React, { useState } from "react";
import rolls from "./assets/rolls.png";
import rollsBack from "./assets/aboutUs.jpg";
import rollsBack2 from "./assets/aboutUs2.jpg";
import lrr from "./assets/lrr.png";
import ard from "./assets/ard.jpg";
import pu from "./assets/pu.jpg";
import dos from "./assets/do.jpg";
import GS from "./assets/GS.jpg";

import pune from "./assets/Pune.png";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import { FaBullseye, FaEye } from "react-icons/fa";
import { GiBullseye } from "react-icons/gi";
import SEO from "./components/SEO";

function About() {
  return (
     <>
          <SEO
            title="City Rides, Intercity & Outstation Cabs | Rolo Transit "
            description="Explore Rolo Transit’s fleet: Micro, Mini, Sedan, and SUV. From daily Pune commutes to outstation trips, we have a ride for every budget."
            keywords="Intercity cabs Pune, Pune to Mumbai taxi, Outstation car rental, Micro cabs, SUV rental Pune, Rolo Services."
            url="https://rolotransit.com/about"
          />
    
       
    
          {/* page content */}
    <div className="App background">
      <Navbar />
      <div className="container-fluid text-center gx-0">
        <div className="">
          {/* Hero Section */}
          <section
            className="hero d-flex pt-md-5 justify-content-center flex-column text-white text-center py-5"
            style={{
              backgroundImage: `url(${rollsBack})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="container pt-md-5 text-start px-3 px-md-0">
              <h1 className="text-bold mb-3" style={{ color: "#FF7F1F" }}>
                Rolo
              </h1>
              <p
                className="text-gray fw-light mb-4"
                style={{
                  fontSize: "clamp(14px, 2vw, 16px)",
                  lineHeight: "1.6",
                }}
              >
                Pioneering Smart Mobility Solutions for Modern India. Seamless, sustainable, <br className="d-none d-md-block" />  and inclusive transportation powered by technology. Rolo Transit is an innovative <br className="d-none d-md-block" /> mobility platform transforming how people and packages travel across cities. 
               
              </p>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </section>
          <section className="py-3" style={{ backgroundColor: "#D25A00" }}>
            <div className="container text-start">
              <div className="row align-items-center justify-content-space-between g-4">
                <div className="col-12 col-md-6">
                 
                  <p
                    style={{
                      fontSize: "clamp(14px, 2vw, 16px)",
                      lineHeight: "1.6",
                      textAlign: "justify",
                    }}
                  >
                   <strong style={{color:"#000000"}}>Rolo Transit Platforms Pvt. Ltd.</strong>{" "}was founded in Pune in 2025 <strong>(CIN: U62099PN2025PTC244476)</strong>. We are an innovative mobility solution committed to transforming smart and easy city travel by making it trustworthy and safe. 
                  </p>

                   <p
                    style={{
                      fontSize: "clamp(14px, 2vw, 16px)",
                      lineHeight: "1.6",
                      textAlign: "justify",
                    }}
                  >
                 Flawlessly connecting drivers and commuters, by utilizing modern technology in our application, travelers can get where they need to go more easily. The customer is our topmost priority, which is why every ride, feature, and service is created with convenience and safety in mind. 

                  </p>

                   <p
                    style={{
                      fontSize: "clamp(14px, 2vw, 16px)",
                      lineHeight: "1.6",
                      textAlign: "justify",
                    }}
                  >
                   At Rolo, we are always focusing on new ideas and standards for the cab service industry. We are working closely to fill the gap between individuals and their transportation needs.  

                  </p>

                   <p
                    style={{
                      fontSize: "clamp(14px, 2vw, 16px)",
                      lineHeight: "1.6",
                      textAlign: "justify",
                    }}
                  >
                  Our goal is to use advanced technology to make daily commuting affordable, effective, and environmentally responsible. As we grow, we aim to broaden our network so that everyone, everywhere, has access to safe transportation. 

                  </p>

                   <p
                    style={{
                      fontSize: "clamp(14px, 2vw, 16px)",
                      lineHeight: "1.6",
                      textAlign: "justify",
                    }}
                  >
                    Our mission is to transform daily commuting by utilizing technology to make urban transport more affordable, environmentally responsible, and effective. As we progress, we aim to expand our network so that reliable transportation is available to everyone, everywhere. 

                  </p>
                    <p
                    style={{
                      fontSize: "clamp(14px, 2vw, 16px)",
                      lineHeight: "1.6",
                      textAlign: "justify",
                    }}
                  >
                    <strong style={{color:"#000000"}}>Headquarters:</strong> CTC No. 1117, Flat No. 5, Shukrawar Peth, Pune. 
                  </p>
                </div>
                <div className="col-12 col-md-6 align-items-center justify-content-center">
                  <img
                    src={rollsBack2}
                    alt="Pune"
                    className="img-fluid rounded"
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="py-5">
            <div className="container">
              <h2
                className="text-center text-bold mb-4 mb-md-5 px-3"
                style={{
                  background:
                    "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: "clamp(28px, 5vw, 40px)",
                }}
              >
                Our Core Values:Safe & Reliable Rides
              </h2>
              <div className="row  justify-content-evenly w-100 g-3 g-md-4">
                {/* Card 1 */}
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <div
                    className="card h-100 p-3 p-md-4 shadow-sm border-0 rounded-4"
                    style={{
                      background:
                        "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                    }}
                  >
                    <div className="card-body text-white">
                      <h4
                        className="card-title text-bold2 mb-3"
                        style={{ fontSize: "clamp(18px, 3vw, 22px)" }}
                      >
                        Safety Always Come First
                      </h4>
                      <p
                        className="card-text fw-light"
                        style={{
                          fontSize: "clamp(12px, 2vw, 14px)",
                          lineHeight: "1.6",
                          textAlign: "justify",
                        }}
                      >
                        Providing a safe environment is vital. Every trip is designed to be worry-free, with insured rides, verified
                        drivers and vehicle checks.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 2 */}
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <div
                    className="card h-100 p-3 p-md-4 shadow-sm border-0 rounded-4"
                    style={{
                      background:
                        "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                    }}
                  >
                    <div className="card-body text-white">
                      <h4
                        className="card-title text-bold2 mb-3"
                        style={{ fontSize: "clamp(18px, 3vw, 22px)" }}
                      >
                        Honesty & Integrity
                      </h4>
                      <p
                        className="card-text fw-light"
                        style={{
                          fontSize: "clamp(12px, 2vw, 14px)",
                          lineHeight: "1.6",
                          textAlign: "justify",
                        }}
                      >
                        Our customers will always know what they are paying for
                        because of fair pricing and real time tracking.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 3 */}
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <div
                    className="card h-100 p-3 p-md-4 shadow-sm border-0 rounded-4"
                    style={{
                      background:
                        "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                    }}
                  >
                    <div className="card-body text-white">
                      <h4
                        className="card-title text-bold2 mb-3"
                        style={{ fontSize: "clamp(18px, 3vw, 22px)" }}
                      >
                        Driving Forward, Together 
                      </h4>
                      <p
                        className="card-text fw-light"
                        style={{
                          fontSize: "clamp(12px, 2vw, 14px)",
                          lineHeight: "1.6",
                          textAlign: "justify",
                        }}
                      >
                        We should all grow together. Our platform supports
                        drivers in developing their careers, earning fairly, and delivering outstanding service  to each and every customer.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-evenly w-100 mt-3 mt-md-5 g-3 g-md-4">
                {/* Card 1 */}
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <div
                    className="card h-100 p-3 p-md-4 shadow-sm border-0 rounded-4"
                    style={{
                      background:
                        "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                    }}
                  >
                    <div className="card-body text-white">
                      <h4
                        className="card-title text-bold2 mb-3"
                        style={{ fontSize: "clamp(18px, 3vw, 22px)" }}
                      >
                        Innovation in transit
                      </h4>
                      <p
                        className="card-text fw-light"
                        style={{
                          fontSize: "clamp(12px, 2vw, 14px)",
                          lineHeight: "1.6",
                          textAlign: "justify",
                        }}
                      >
                        We use advanced technology tomake our customer's travel simple from quick bookings to digital payments.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 2 */}
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <div
                    className="card h-100 p-3 p-md-4 shadow-sm border-0 rounded-4"
                    style={{
                      background:
                        "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                    }}
                  >
                    <div className="card-body text-white">
                      <h4
                        className="card-title text-bold2 mb-3"
                        style={{ fontSize: "clamp(18px, 3vw, 22px)" }}
                      >
                        Sustainable Future
                      </h4>
                      <p
                        className="card-text fw-light"
                        style={{
                          fontSize: "clamp(12px, 2vw, 14px)",
                          lineHeight: "1.6",
                          textAlign: "justify",
                        }}
                      >
                        With eco-friendly ride options and smarter routing,
                        we're doing our part to reduce emissions and promote
                        green mobility.
                      </p>
                    </div>
                  </div>
                </div>
                {/* Card 3 */}
                <div className="col-12 col-md-4 mb-3 mb-md-0">
                  <div
                    className="card h-100 p-3 p-md-4 shadow-sm border-0 rounded-4"
                    style={{
                      background:
                        "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                    }}
                  >
                    <div className="card-body text-white">
                      <h4
                        className="card-title text-bold2 mb-3"
                        style={{ fontSize: "clamp(18px, 3vw, 22px)" }}
                      >
                        Round-the-clock Operation
                      </h4>
                      <p
                        className="card-text fw-light"
                        style={{
                          fontSize: "clamp(12px, 2vw, 14px)",
                          lineHeight: "1.6",
                          textAlign: "justify",
                        }}
                      >
                         We're always ready to move our customers safely, quickly and comfortably, whether it’s day or night, urban or intercity. 

                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p
              className="w-100 w-md-50 mx-auto mt-5 pt-5 px-3 px-md-0"
              style={{ fontSize: "16px", lineHeight: "1.6" }}
            >
              Our principles at Rolo Transit are more than just words they drive
              every decision we make, every ride we provide, and every smile we
              deliver. We believe,
            </p>
            <h2
              className="text-center text-bold mb-5 px-3"
              style={{
                background:
                  "linear-gradient(90deg,rgba(255, 127, 31, 1) 0%, rgba(210, 90, 0, 1) 80%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontSize: "clamp(24px, 5vw, 40px)",
                marginTop: "0px",
                padding: "0px",
                lineHeight: "1.2",
              }}
            >
              "Your ride our Pride".
            </h2>
          </section>

          {/* Vision & Mission */}
          <section
            className=" text-white pb-5 rounded-0 text-center"
            style={{ maxWidth: "100%" }}
          >
            <div className="container text-center text-light">
              <div className="row g-4">
                 <div className="col-12 col-md-6">
                  <div className="p-3 p-md-4">
          <h2
  className="d-flex flex-column align-items-center justify-content-center"
  style={{
    fontSize: "clamp(28px, 5vw, 36px)",
    textAlign: "center",
    gap: "8px"
  }}
>
  <GiBullseye
    style={{
      color: "#FF7F1F",
      fontSize: "clamp(40px, 6vw, 50px)" // Bigger icon
    }}
  />
  Mission
</h2>

                    <p
                      className="fw-light text-gray"
                      style={{
                        fontSize: "clamp(14px, 2vw, 16px)",
                        lineHeight: "1.6",
                        textAlign: "justify",
                      }}
                    >
                      To be India’s most trusted technology-driven mobility platform and transform the way India moves through innovation, reliability, and customer-centric transportation solutions. To empower cities and communities through smart, safe, and seamless travel experiences. 

                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="p-3 p-md-4 pb-md-5">
                   <h2
  className="d-flex flex-column align-items-center justify-content-center"
  style={{
    fontSize: "clamp(28px, 5vw, 36px)",
    textAlign: "center",
    gap: "8px"
  }}
>
  <FaEye
    style={{
      color: "#FF7F1F",
      fontSize: "clamp(40px, 6vw, 50px)" // Bigger icon
    }}
  />
  Vision
</h2>
                    <p
                      className="fw-light text-gray"
                      style={{
                        fontSize: "clamp(14px, 2vw, 16px)",
                        lineHeight: "1.6",
                        textAlign: "justify",
                      }}
                    >
                      To redefine mobility in India through seamless, inclusive
                      transit solutions that support people, businesses, and
                      sustainable communities.
                    </p>
                  </div>
                </div>
               
              </div>
            </div>
          </section>

          <section
            className="py-5 text-white glass rounded-0"
            style={{ maxWidth: "100%" }}
          >
            <h2
              className="text-center text-md-start text-bold mb-4 mb-md-5 ms-md-5 px-3 px-md-0"
              style={{ fontSize: "clamp(24px, 5vw, 32px)" }}
            >
              Quick Guide to Rolo Transit
            </h2>
            <div className="container text-start">
              {/* Card 1: Text Left, Image Right */}
              <div className="border-0 shadow-sm overflow-hidden mb-3 mb-md-4 rounded-3">
                <div className="row g-0 align-items-center">
                  <div className="col-12 col-md-6 order-1 order-md-1 p-3 p-md-4 p-lg-5">
                    <h2
                      className="text-bold mb-2 mb-md-3"
                      style={{
                        background:
                          "linear-gradient(90deg, #FF7F1F 0%, #D25A00 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontSize: "clamp(28px, 5vw, 40px)",
                        lineHeight: "1.2",
                      }}
                    >
                      Getting Started
                    </h2>
                    <p
                      className="fw-light text-white mb-0"
                      style={{
                        fontSize: "clamp(13px, 2vw, 16px)",
                        lineHeight: "1.6",
                      }}
                    >
                      Sign up, set your location, and choose your preferred ride type: Micro, Mini, Sedan, SUV 

                    </p>
                  </div>
                  <div className="col-12 col-md-6 order-2 order-md-2">
                    <img
                      src={GS}
                      alt="Getting Started"
                      className="img-fluid w-100"
                      style={{
                         objectFit: "cover",
    height: "280px",   // 👈 fixed smaller height
    width: "100%"
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Card 2: Image Left, Text Right */}
              <div className="border-0 shadow-sm overflow-hidden mb-3 mb-md-4 rounded-3">
                <div className="row g-0 align-items-center">
                  <div className="col-12 col-md-6 order-2 order-md-1">
                    <img
                      src={ard}
                      alt="Assigning Rider & Driver"
                      className="img-fluid w-100 "
                      style={{
                                            objectFit: "cover",
    height: "280px",   // 👈 fixed smaller height
    width: "100%"
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-6 order-1 order-md-2 p-3 p-md-4 p-lg-5">
                    <h2
                      className="text-bold mb-2 mb-md-3"
                      style={{
                        background:
                          "linear-gradient(90deg, #FF7F1F 0%, #D25A00 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontSize: "clamp(28px, 5vw, 40px)",
                        lineHeight: "1.2",
                      }}
                    >
                      Assigning Rider & Driver
                    </h2>
                    <p
                      className="fw-light text-white mb-0"
                      style={{
                        fontSize: "clamp(13px, 2vw, 16px)",
                        lineHeight: "1.6",
                      }}
                    >
                      Once you confirm your ride, Rolo instantly connects you
                      with the nearest verified driver. You'll see their name,
                      photo, and vehicle details in the app.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 3: Text Left, Image Right */}
              <div className="border-0 shadow-sm overflow-hidden mb-3 mb-md-4 rounded-3">
                <div className="row g-0 align-items-center">
                  <div className="col-12 col-md-6 order-1 order-md-1 p-3 p-md-4 p-lg-5">
                    <h2
                      className="text-bold mb-2 mb-md-3"
                      style={{
                        background:
                          "linear-gradient(90deg, #FF7F1F 0%, #D25A00 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontSize: "clamp(28px, 5vw, 40px)",
                        lineHeight: "1.2",
                      }}
                    >
                      Pick Up
                    </h2>
                    <p
                      className="fw-light text-white mb-0"
                      style={{
                        fontSize: "clamp(13px, 2vw, 16px)",
                        lineHeight: "1.6",
                      }}
                    >
                      Track your driver in real time and get notified as they
                      arrive at your pickup location.
                    </p>
                  </div>
                  <div className="col-12 col-md-6 order-2 order-md-2">
                    <img
                      src={pu}
                      alt="Pick Up"
                      className="img-fluid w-100 "
                      style={{
                        objectFit: "cover",
    height: "280px",   // 👈 fixed smaller height
    width: "100%"
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Card 4: Image Left, Text Right */}
              <div className="border-0 shadow-sm overflow-hidden mb-3 mb-md-4 rounded-3">
                <div className="row g-0 align-items-center">
                  <div className="col-12 col-md-6 order-2 order-md-1">
                    <img
                      src={dos}
                      alt="Drop Off"
                      className="img-fluid w-100 "
                      style={{
                                            objectFit: "cover",
    height: "280px",   // 👈 fixed smaller height
    width: "100%"
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-6 order-1 order-md-2 p-3 p-md-4 p-lg-5">
                    <h2
                      className="text-bold mb-2 mb-md-3"
                      style={{
                        background:
                          "linear-gradient(90deg, #FF7F1F 0%, #D25A00 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontSize: "clamp(28px, 5vw, 40px)",
                        lineHeight: "1.2",
                      }}
                    >
                      Drop Off
                    </h2>
                    <p
                      className="fw-light text-white mb-0"
                      style={{
                        fontSize: "clamp(13px, 2vw, 16px)",
                        lineHeight: "1.6",
                      }}
                    >
                      Enjoy a comfortable, safe journey. You can pay via cash,
                      card, or online options once you reach your destination.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 5: Text Left, Image Right */}
              <div className="border-0 shadow-sm overflow-hidden mb-3 mb-md-4 rounded-3">
                <div className="row g-0 align-items-center">
                  <div className="col-12 col-md-6 order-1 order-md-1 p-3 p-md-4 p-lg-5">
                    <h2
                      className="text-bold mb-2 mb-md-3"
                      style={{
                        background:
                          "linear-gradient(90deg, #FF7F1F 0%, #D25A00 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontSize: "clamp(28px, 5vw, 40px)",
                        lineHeight: "1.2",
                      }}
                    >
                      Leaving Review & Rating
                    </h2>
                    <p
                      className="fw-light text-white mb-0"
                      style={{
                        fontSize: "clamp(13px, 2vw, 16px)",
                        lineHeight: "1.6",
                      }}
                    >
                      After your ride, rate your experience and share “quick feedback; it helps us maintain top service quality for
                      everyone
                    </p>
                  </div>
                  <div className="col-12 col-md-6 order-2 order-md-2">
                    <img
                      src={lrr}
                      alt="Leaving Review & Rating"
                      className="img-fluid w-100 "
                      style={{
                                            objectFit: "cover",
    height: "280px",   // 👈 fixed smaller height
    width: "100%"
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Core Values */}

          {/* Team Section */}
          {/* <section className="glass2 text-white py-5 rounded-0" style={{ maxWidth: '100%' }}>
                        <div className="container text-center">
                            <h2>Our Team</h2>
                            <p>
                                Led by a team of experienced entrepreneurs and tech experts from the
                                mobility sector.
                            </p>
                            <div className="row g-4">
                                {[
                                    { name: "Founder Name", role: "CEO & Co-founder" },
                                    { name: "Founder Name", role: "CTO & Co-founder" },
                                    { name: "Team Member", role: "Operations" },
                                ].map((member, i) => (
                                    <div key={i} className="col-md-4">
                                        <div className="card p-3 shadow-sm">
                                            <img
                                                src="https://via.placeholder.com/200"
                                                className="rounded-circle mx-auto mb-3"
                                                alt={member.name}
                                            />
                                            <h5>{member.name}</h5>
                                            <p>{member.role}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section> */}

          {/* Milestones */}
          {/* <section className="py-5">
                        <div className="container">
                            <h2 className="text-center mb-4">Milestones</h2>
                            <div className="timeline">
                                <div className="event">
                                    <h5>July 2025</h5>
                                    <p>Incorporation and app beta launch.</p>
                                </div>
                                <div className="event">
                                    <h5>August 2025</h5>
                                    <p>Expansion to key cities like Mumbai, Delhi, and Bangalore.</p>
                                </div>
                                <div className="event">
                                    <h5>Future Goals</h5>
                                    <p>Nationwide coverage by 2026 and international partnerships.</p>
                                </div>
                            </div>
                        </div>
                    </section> */}

          {/* Call to Action */}
          {/* <div class="row align-items-center background2" style={{ backgroundColor: '#e2e2e24d' }}>
                        <div class="col-12 col-md-6 px-4 mb-4 mb-md-0">
                            <h2 className="text-bold">Ready to join the <span className="gradient-text">Rolo revolution</span></h2>
                            <p className="mb-4">Explore our services or contact us today.</p>
                            
                            <a href="#" className="btn btn-light btn-lg">
                                Download App
                            </a>
                            <a href="#" className="btn btn-outline-light btn-lg ms-2">
                                Contact Us
                            </a>
                        </div>

                        <div class="col-12 col-md-6 px-4 bg-light text-dark">
                            <div class="p-4 shadow-sm">
                                <h3 class="mb-4">Send Us A Message</h3>
                                <form className='text-start'>
                                    <div class="mb-3">
                                        <label for="name" class="form-label">Name</label>
                                        <input type="text" class="form-control" id="name" placeholder="Your name" required />
                                    </div>

                                    <div class="mb-3">
                                        <label for="email" class="form-label">Email</label>
                                        <input type="email" class="form-control" id="email" placeholder="you@example.com" required />
                                    </div>

                                    <div class="mb-3">
                                        <label for="message" class="form-label">Message</label>
                                        <textarea class="form-control" id="message" rows="4" placeholder="Your message..." required></textarea>
                                    </div>

                                    <div class="">
                                        <button type="submit" class="btn btn-dark rounded-pill py-2">Send Message</button>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div> */}
        </div>
      </div>
      <Footer />
    </div>
    </>
  );
}

export default About;
